/**
 * Caclculates the hour, minute and second values from a given number of seconds
 * to be used in a formatted 'timer' string
 * @param  {Number} s Total number of seconds
 * @returns {Object}   Object containing hours, minutes, seconds, and total seconds
 */
export function getTimeFromSeconds( s ) {
    const totalSeconds = Math.ceil( s );
    const hours = Math.floor( totalSeconds / 3600 );
    const remainder = totalSeconds % 3600;
    const minutes = Math.floor( remainder / 60 );
    const seconds = remainder % 60;

    return {
        totalSeconds,
        seconds,
        minutes,
        hours
    };
}

/**
 * Caclculates the number of seconds 'now' and some 
 * previous timestamp, rounded to the nearest second
 * @param  {Object} prevTime Date object representing the previous timestamp
 * @return {Number}          Number of seconds
 */
export function getSecondsFromPrevTime( prevTime ) {
    const now = new Date().getTime();
    const milliSecondsDistance = now - prevTime;
    if ( milliSecondsDistance > 0 ) {
        const val = milliSecondsDistance / 1000;
        return Math.round( val );
    }
    return 0;
}

/**
 * Formats a set of hours, minutes, and seconds values as a string e.g. 'HH:MM:SS'
 * @param  {Object} values object containing hours, minutes, and seconds properties
 * @return {String}        Formatted string
 */
export function formatTimerValues( { hours, minutes, seconds } ) {
    let hourStr = hours.toString();
    let minutesStr = minutes.toString();
    let secondsStr = seconds.toString();
    if ( hourStr.length === 1 ) {
        hourStr = '0' + hourStr;
    }
    if ( minutesStr.length === 1 ) {
        minutesStr = '0' + minutesStr;
    }
    if ( secondsStr.length === 1 ) {
        secondsStr = '0' + secondsStr;
    }
    const formatted = `${ hourStr }:${ minutesStr }:${ secondsStr }`;
    return formatted;
}